/**
 * Which surface this renderer mounts Views on. The overlay's sidepanel sits on
 * Home, shares its history with main through GlobalState, and answers to the
 * swipe gesture. Any other renderer is a popout window, whose stack is rooted
 * on the popped View and never leaves that window. Tests have no renderer name
 * and get the overlay's behavior.
 */
export const isSidepanelOverlay = typeof window === 'undefined' || window.__RENDERER_NAME === 'overlay'

export const isViewPopout = !isSidepanelOverlay

/**
 * Whether this surface has a window to pop a View out to. A popout window is
 * already that window, so its rows and headers offer no "Open in new window".
 */
export const canPopOutView = isSidepanelOverlay
